<script setup lang="ts">
import { computed } from 'vue'
import { VAddressSuggest } from '@/widgets/AddressSuggest'
import { TextFieldList } from '../../model/types.ts'
import { useMandatoryFieldError } from '../../model/useMandatoryFieldError'

defineOptions({ inheritAttrs: false })

const props = defineProps({
  label: {
    type: String,
    default: '',
  },
  variant: {
    type: String,
    default: 'outlined',
  },
  density: {
    type: String,
    default: 'compact',
  },
  hideDetails: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  readonly: {
    type: Boolean,
    default: false,
  },
  mandatory: {
    default: false,
  },
  showMandatoryError: {
    type: Boolean,
    default: false,
  },
})

const value = defineModel<string>({ default: '' })

const {
  visible: mandatoryErrorVisible,
  message: mandatoryErrorMessage,
  markTouched,
  registerUserInteraction,
} = useMandatoryFieldError(
  () => ({
    showMandatoryError: props.showMandatoryError,
    mandatory: props.mandatory,
    type: TextFieldList.ADDRESS,
  }),
  () => value.value,
)

const isDisabled = computed(() => props.disabled || props.readonly)
const hideDetailsState = computed(() =>
  mandatoryErrorVisible.value ? false : props.hideDetails,
)
</script>

<template>
  <VAddressSuggest
    v-model="value"
    :label="label"
    :variant="variant"
    :density="density"
    :hide-details="hideDetailsState"
    :disabled="isDisabled"
    :error="mandatoryErrorVisible ? true : undefined"
    :error-messages="mandatoryErrorVisible ? mandatoryErrorMessage : undefined"
    @pointerdown="registerUserInteraction()"
    @blur="markTouched"
  />
</template>
